import { render, staticRenderFns } from "./product-drilldown.vue?vue&type=template&id=083510d0&"
import script from "./product-drilldown.vue?vue&type=script&lang=js&"
export * from "./product-drilldown.vue?vue&type=script&lang=js&"
import style0 from "./product-drilldown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports